/**
 * Created by AlexanderC on 5/25/15.
 */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Runtime = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Interface2 = require('../../OOP/Interface');

var _Response = require('./Response');

var _ErrorResponse = require('./ErrorResponse');

var _Request = require('./Request');

var _InvalidCognitoIdentityException = require('./Exception/InvalidCognitoIdentityException');

var _MissingUserContextException = require('./Exception/MissingUserContextException');

var _Context = require('./Context');

var _Sandbox = require('../../Runtime/Sandbox');

var _Resolver = require('./Resolver');

var _awsSdk = require('aws-sdk');

var _awsSdk2 = _interopRequireDefault(_awsSdk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Lambda runtime context
 */
let Runtime = exports.Runtime = function (_Interface) {
  _inherits(Runtime, _Interface);

  /**
   * @param {Object} kernel
   */
  function Runtime(kernel) {
    _classCallCheck(this, Runtime);

    var _this2 = _possibleConstructorReturn(this, (Runtime.__proto__ || Object.getPrototypeOf(Runtime)).call(this, ['handle']));

    _this2._kernel = kernel;
    _this2._request = null;
    _this2._context = null;
    _this2._resolver = null;

    _this2._loggedUserId = null;
    _this2._forceUserIdentity = false;
    _this2._contextSent = false;

    _this2._calleeConfig = null;

    _this2._fillDenyMissingUserContextOption();
    return _this2;
  }

  /**
   * @returns {null|Context}
   */


  _createClass(Runtime, [{
    key: 'validateInput',


    /**
     * @param {String} schemaName
     * @param {Function} cb
     * @returns {Runtime}
     */
    value: function validateInput(schemaName, cb) {
      let validation = this._kernel.get('validation');

      validation.validateRuntimeInput(this, schemaName, cb);

      return this;
    }

    /**
     * @param {Object} event
     * @param {Object} context
     * @param {Function} lambdaCallback
     * @returns {Runtime}
     */

  }, {
    key: 'run',
    value: function run(event, context) {
      let lambdaCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      this._context = new _Context.Context(context);
      this._request = new _Request.Request(event);

      if (lambdaCallback) {
        this._resolver = new _Resolver.Resolver(lambdaCallback);

        this._resolver.registerSucceedCallback(this.kernel.kernelCleanup.bind(this.kernel));
      }

      this._context.waitForEmptyEventLoop();

      this.logService.rumLog({
        service: 'deep-core',
        resourceType: 'Lambda',
        resourceId: this._context.invokedFunctionArn,
        eventName: 'Run'
      });

      new _Sandbox.Sandbox(() => {
        this._fillUserContext().then(() => {
          if (!this._loggedUserId && this._forceUserIdentity) {
            throw new _MissingUserContextException.MissingUserContextException();
          }

          this._initDBPartitionKey();

          this._runValidate(this.validationSchema, validatedData => {
            if (this._context._lambdaContext.overheadSubSegment) {
              this._context._lambdaContext.overheadSubSegment.close();
            }

            this.handle(validatedData);
          });
        }).catch(e => this.createError(e).send());
      }).fail(error => {
        this.createError(error).send();
      }).run();

      return this;
    }

    /**
     * @param {String} validationSchema
     * @param {Function} cb
     * @private
     */

  }, {
    key: '_runValidate',
    value: function _runValidate(validationSchema, cb) {
      if (!validationSchema) {
        cb(this._request);
        return;
      }

      let validationSchemaName = validationSchema;

      if (typeof validationSchema !== 'string') {
        validationSchemaName = this._injectValidationSchema(validationSchema);
      }

      this.validateInput(validationSchemaName, cb);
    }

    /**
     * @param {Object} schema
     * @param {String|null} name
     * @returns {String}
     * @private
     */

  }, {
    key: '_injectValidationSchema',
    value: function _injectValidationSchema(schema) {
      let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      let validation = this._kernel.get('validation');

      name = name || `DeepHandlerValidation_${new Date().getTime()}`;

      validation.setGuessSchema(name, schema);

      return name;
    }

    /**
     * @param {String|Error|*} error
     * @returns {ErrorResponse}
     */

  }, {
    key: 'createError',
    value: function createError(error) {
      return new _ErrorResponse.ErrorResponse(this, error);
    }

    /**
     * @param {Object} data
     * @returns {Response}
     */

  }, {
    key: 'createResponse',
    value: function createResponse(data) {
      return new _Response.Response(this, data);
    }

    /**
     * @param {Object} data
     * @param {Number} ttl
     * @param {Function} callback
     */

  }, {
    key: 'createCachedResponse',
    value: function createCachedResponse(data) {
      let ttl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      let callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : response => response.send();

      let publicCache = this._kernel.get('cache').shared;
      let publicCacheKey = publicCache.buildKeyFromLambdaRuntime(this);
      let response = new _Response.Response(this, data);

      publicCache.assure(publicCacheKey, { body: data }, ttl, () => {
        callback(response);
      });
    }

    /**
     * @returns {String}
     */

  }, {
    key: '_fillDenyMissingUserContextOption',


    /**
     * @private
     */
    value: function _fillDenyMissingUserContextOption() {
      if (this._kernel.config.hasOwnProperty('forceUserIdentity')) {
        this._forceUserIdentity = this._kernel.config.forceUserIdentity;
      }
    }

    /**
     * @returns {Runtime}
     * @private
     */

  }, {
    key: '_initDBPartitionKey',
    value: function _initDBPartitionKey() {
      if (!this.kernel.accountMicroservice || !this.forceUserIdentity) {
        return this;
      }

      let db = this.dbService;
      let user = this.securityService.token && this.securityService.token.user;
      let partitionKey = Runtime.DB_ANONYMOUS_PARTITION;

      if (user && user.ActiveAccount) {
        partitionKey = user.ActiveAccount.Id;
      }

      db.setDynamoDBPartitionKey(partitionKey);

      return this;
    }

    /**
     * Retrieves logged user id from lambda context
     *
     * @private
     * @returns {Promise}
     */

  }, {
    key: '_fillUserContext',
    value: function _fillUserContext() {
      if (this._context && this._context.identity && this._context.identity.cognitoIdentityPoolId && this._context.identity.cognitoIdentityId) {
        let identityPoolId = this._context.identity.cognitoIdentityPoolId;

        if (this.securityService.identityPoolId !== identityPoolId && !this._kernel.container.localBackend) {

          return Promise.reject(new _InvalidCognitoIdentityException.InvalidCognitoIdentityException(identityPoolId));
        }

        // inject lambda context into security service
        // and instantiate security token without loading user credentials
        return this.securityService.warmupBackendLogin(this._context).then(credentials => {
          let dbService = this.dbService;

          _awsSdk2.default.config.credentials = credentials;
          credentials && dbService.overwriteCredentials(credentials);

          this._loggedUserId = this._context.identity.cognitoIdentityId;
        });
      }

      return Promise.resolve(null);
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'context',
    get: function get() {
      return this._context;
    }

    /**
     * @returns {null|Resolver}
     */

  }, {
    key: 'resolver',
    get: function get() {
      return this._resolver;
    }

    /**
     * @returns {Boolean}
     */

  }, {
    key: 'contextSent',
    get: function get() {
      return this._contextSent;
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'loggedUserId',
    get: function get() {
      return this._loggedUserId;
    }

    /**
     * @returns {Boolean}
     */

  }, {
    key: 'forceUserIdentity',
    get: function get() {
      return this._forceUserIdentity;
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'kernel',
    get: function get() {
      return this._kernel;
    }

    /**
     * @returns {Function}
     */

  }, {
    key: 'lambda',
    get: function get() {
      let _this = this;

      return function (event, context) {
        _this.run(event, context);
      };
    }
  }, {
    key: 'calleeName',
    get: function get() {
      if (this._context && this._context.has('invokedFunctionArn')) {
        let calleeArn = this._context.getOption('invokedFunctionArn');

        return calleeArn.replace(/^.+:function:/i, '');
      }

      return null;
    }

    /**
     * @returns {null|Object}
     */

  }, {
    key: 'calleeConfig',
    get: function get() {
      if (!this._calleeConfig && this._context && this._kernel && this._context.has('invokedFunctionArn')) {

        let resource = this._kernel.get('resource');
        let calleeArn = this._context.getOption('invokedFunctionArn');

        this._calleeConfig = resource.getActionConfig(calleeArn);
      }

      return this._calleeConfig;
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'validationSchema',
    get: function get() {
      return this.calleeConfig ? this.calleeConfig.validationSchema || null : null;
    }

    /**
     * @returns {Request}
     */

  }, {
    key: 'request',
    get: function get() {
      return this._request;
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'securityService',
    get: function get() {
      return this.kernel.get('security');
    }

    /**
     * @returns {DB}
     */

  }, {
    key: 'dbService',
    get: function get() {
      return this.kernel.get('db');
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'logService',
    get: function get() {
      return this.kernel.get('log');
    }
  }], [{
    key: 'DB_ANONYMOUS_PARTITION',
    get: function get() {
      return 'anonymous';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'VALIDATION_SCHEMAS_DIR',
    get: function get() {
      return '__deep_validation_schemas__';
    }
  }]);

  return Runtime;
}(_Interface2.Interface);


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/AWS/Lambda/Runtime.js
// module id = 367
// module chunks = 0